module.exports = __webpack_public_path__ + "img/uso_quebra_ventos_2.ee687e1b.webp";